import { Button, Col, Modal, Row, Typography } from "antd";
import React, { useState } from "react";
import { contributors } from "./constants";

const { Text, Title } = Typography;

const HallOfFame: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button type="text" onClick={() => setOpen(true)} style={{ color: "grey", padding: 0 }}>
        Hall of Fame
      </Button>
      <Modal
        title={<Title level={4}>Hall of Fame</Title>}
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width="90%"
        footer={null}
        bodyStyle={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)" }}
      >
        <Text style={{ fontSize: "1.2em" }}>Nettsiden er programmert av: </Text>
        {Object.entries(contributors).map(([year, persons]) => (
          <Row key={year} gutter={[0, 4]} style={{ paddingTop: "1.5em" }}>
            <Col span={24}>
              <Text italic>{year}</Text>
            </Col>
            {persons.map(person => (
              <Col
                key={person.name}
                style={{ width: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              >
                <Text>{person.name}</Text>
              </Col>
            ))}
          </Row>
        ))}
      </Modal>
    </>
  );
};

export default HallOfFame;
